<template>
  <div
    v-if="props.typeId && $store.getters['requests/getRequestsType'](props.typeId)"
    class="flex items-center h-full"
  >
    <el-tooltip
      :content="$store.getters['requests/getRequestsType'](props.typeId).nameTooltip"
      placement="right"
      :disabled="props.client?.lang !== 'ua'"
    >
      <div class="flex items-center h-full">
        <component
          :is="$store.getters['requests/getRequestsType'](props.typeId).icon"
          :class="`color-${$store.getters['requests/getRequestsType'](props.typeId).color}`"
          class="icon mr-2"
        />
        <div
          class="font-semibold"
          :class="{ 'text-danger-500': props.typeId === $store.state.requests.EMERGENCY_TYPE_ID }"
        >
          {{ $store.getters['requests/getRequestsType'](props.typeId).name }}
        </div>
      </div>
    </el-tooltip>
  </div>
</template>

<script setup>
const props = defineProps({
  typeId: {
    type: Number,
    default: null,
  },
  client: {
    type: Object,
    default: null,
  },
});
</script>
